import React from 'react';
import TimelineItem from './TimeLineItem';
import { educationData, experienceData } from '../../api/experienceData';
import './DualTimeline.css';

const DualTimeline = () => {
  const freelancerData = experienceData.filter(
    (item) => item.category === 'freelancer'
  );

  const jobExperienceData = experienceData.filter(
    (item) => item.category === 'job'
  );

  return (
    <div className="dual-timeline-container">
      <div className="row">

        <div className="col-lg-6 order-2 order-lg-1">
          {freelancerData.length > 0 && (
            <div className="timeline-section freelancer-section">
              <div className="section-header">
                <div className="section-icon">
                  <i className="fas fa-laptop-code"></i>
                </div>
                <h2>Freelancer</h2>
                <div className="section-line"></div>
              </div>

              <div className="timeline-wrapper">
                {freelancerData.map((item) => (
                  <TimelineItem
                    key={item.id}
                    item={item}
                    type="experience"
                  />
                ))}
              </div>
            </div>
          )}

          <div className="timeline-section education-section">
            <div className="section-header">
              <div className="section-icon">
                <i className="fas fa-graduation-cap"></i>
              </div>
              <h2>Eğitim</h2>
              <div className="section-line"></div>
            </div>

            <div className="timeline-wrapper">
              {educationData.map((item) => (
                <TimelineItem
                  key={item.id}
                  item={item}
                  type="education"
                />
              ))}
            </div>
          </div>
        </div>

        <div className="col-lg-6 order-1 order-lg-2">
          <div className="timeline-section experience-section">
            <div className="section-header">
              <div className="section-icon">
                <i className="fas fa-briefcase"></i>
              </div>
              <h2>Deneyim</h2>
              <div className="section-line"></div>
            </div>

            <div className="timeline-wrapper">
              {jobExperienceData.map((item) => (
                <TimelineItem
                  key={item.id}
                  item={item}
                  type="experience"
                />
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default DualTimeline;
